<mbs-custom-profile-notification-utility (onPostActionChanged)="onPostActionChanged($event)"
                                         [includeConnectWise]="includeConnectWise"
                                         [postActions]="postActions">
</mbs-custom-profile-notification-utility>
